import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    <path fill="currentColor" fillRule="evenodd" d="M8 2.833a.5.5 0 0 1 .5.5v9.334a.5.5 0 1 1-1 0V3.333a.5.5 0 0 1 .5-.5" clipRule="evenodd" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.354 8.313a.5.5 0 0 1 0 .707l-4 4a.5.5 0 0 1-.708-.707l4-4a.5.5 0 0 1 .708 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.646 8.313a.5.5 0 0 1 .708 0l4 4a.5.5 0 1 1-.708.707l-4-4a.5.5 0 0 1 0-.707"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowDown;
